export default __webpack_public_path__ + "static/grammatically-transitive-past-c9262fc7ea0c11591ffef08272889d77.svg";